import { render, staticRenderFns } from "./PeopleFilters.vue?vue&type=template&id=28a836f4"
import script from "./PeopleFilters.vue?vue&type=script&lang=js"
export * from "./PeopleFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports